import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { filter, map, take } from 'rxjs'
import { Store } from '@ngxs/store'
import { RouteName } from '../enums/route-name.enum'
import { UserState } from '../../store/user/user.state'

export const rpmTabletGuard: CanActivateFn = (route, state) => {
  const userState = inject(UserState)
  const store = inject(Store)

  const router = inject(Router)

  return userState.state$.pipe(
    filter(state => !!state.user),
    take(1),
    map(d => {
      const isUserAdmin = store.selectSnapshot(UserState.isUserAdmin)
      if (!isUserAdmin) {
        router.navigateByUrl('/' + RouteName.Reports)
        return false
      }
      return isUserAdmin
    })
  )
}
